import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';

class DiagnosticToolSendShareableLinkResource extends BaseResource {
  send(formId: string, email: string): Promise<void> {
    return this.postData(Route.TOOLS_DIAGNOSTIC_SENDFORMLINK, { formId, email });
  }
}

export default new DiagnosticToolSendShareableLinkResource();
